import { castArray, flatMap, keys } from "lodash";

export function query(url: string, params: any) {
  const queryParams = flatMap(keys(params),
    (name) => castArray(params[name]).map((v) => `${name}=${v}`));
  return `${url}?${queryParams.join("&")}`;
}
